import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { DiagnosticsPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/diagnostics';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/diagnostics/')({
  component: DiagnosticsPage,
  errorComponent: ErrorBoundary,
});
